import { render, staticRenderFns } from "./TrialbalanceReport.vue?vue&type=template&id=1b540fe1"
import script from "./TrialbalanceReport.vue?vue&type=script&lang=js"
export * from "./TrialbalanceReport.vue?vue&type=script&lang=js"
import style0 from "./TrialbalanceReport.vue?vue&type=style&index=0&id=1b540fe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports